/**
 * Kazakan Cognitive Test: Aggregated Question Bank Expansion
 * Merges 210 high-entropy stochastic templates across all 7 cognitive dimensions
 * Total Bank Size: 56 base + 210 expanded = 266 unique template families (38 per domain)
 */

import { EXPANDED_ABSTRACT_TEMPLATES } from './bank-expansion-abstract.js';
import { EXPANDED_QUANTITATIVE_TEMPLATES } from './bank-expansion-quant.js';
import { EXPANDED_SPATIAL_TEMPLATES } from './bank-expansion-spatial.js';
import { EXPANDED_VERBAL_TEMPLATES } from './bank-expansion-verbal.js';
import { EXPANDED_MEMORY_TEMPLATES } from './bank-expansion-memory.js';
import { EXPANDED_SPEED_TEMPLATES } from './bank-expansion-speed.js';
import { EXPANDED_SOCIAL_TEMPLATES } from './bank-expansion-social.js';

import { ADVANCED_ABSTRACT_TEMPLATES } from './bank-adv-abstract.js';
import { ADVANCED_QUANTITATIVE_TEMPLATES } from './bank-adv-quant.js';
import { ADVANCED_SPATIAL_TEMPLATES } from './bank-adv-spatial.js';
import { ADVANCED_VERBAL_TEMPLATES } from './bank-adv-verbal.js';
import { ADVANCED_MEMORY_TEMPLATES } from './bank-adv-memory.js';
import { ADVANCED_SPEED_TEMPLATES } from './bank-adv-speed.js';
import { ADVANCED_SOCIAL_TEMPLATES } from './bank-adv-social.js';

export const ALL_EXPANDED_TEMPLATES = [
  ...EXPANDED_ABSTRACT_TEMPLATES,
  ...EXPANDED_QUANTITATIVE_TEMPLATES,
  ...EXPANDED_SPATIAL_TEMPLATES,
  ...EXPANDED_VERBAL_TEMPLATES,
  ...EXPANDED_MEMORY_TEMPLATES,
  ...EXPANDED_SPEED_TEMPLATES,
  ...EXPANDED_SOCIAL_TEMPLATES,
  ...ADVANCED_ABSTRACT_TEMPLATES,
  ...ADVANCED_QUANTITATIVE_TEMPLATES,
  ...ADVANCED_SPATIAL_TEMPLATES,
  ...ADVANCED_VERBAL_TEMPLATES,
  ...ADVANCED_MEMORY_TEMPLATES,
  ...ADVANCED_SPEED_TEMPLATES,
  ...ADVANCED_SOCIAL_TEMPLATES
];
